import * as React from "react";
const SvgFiRrGrinSquintTears = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grin-squint-tears_svg__a)">
      <path
        fill="#062147"
        d="M10.515 18.782a1.001 1.001 0 0 1-.329-1.817 15.4 15.4 0 0 0 4.079-2.7 15.4 15.4 0 0 0 2.7-4.079 1 1 0 0 1 1.817.329 6.69 6.69 0 0 1-8.267 8.267M6.627 18.3c-5.954 7.53 6.93 7.556.974 0a.636.636 0 0 0-.974 0M4.935 4.923a10.04 10.04 0 0 1 13.058-.94 1 1 0 1 0 1.2-1.6 12.006 12.006 0 0 0-16.8 16.8 1 1 0 0 0 1.6-1.2 10.04 10.04 0 0 1 .942-13.06M23 11.028a1 1 0 0 0-1 1A10.057 10.057 0 0 1 12.025 22a1 1 0 1 0 0 2A12.067 12.067 0 0 0 24 12.031a1 1 0 0 0-1-1.003M18.307 7.6c7.559 5.954 7.52-6.929 0-.974a.64.64 0 0 0 0 .974M12.2 3.948a1 1 0 0 0-1.176.784l-.708 3.536a1.01 1.01 0 0 0 1.177 1.177l3.536-.707a1 1 0 0 0-.393-1.961l-2.064.412.412-2.064a1 1 0 0 0-.784-1.177m-3.932 6.364-3.536.708a1 1 0 1 0 .393 1.96l2.064-.412-.412 2.064a1 1 0 1 0 1.961.393l.707-3.536a1 1 0 0 0-1.177-1.177"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grin-squint-tears_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrinSquintTears;
